<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="100128"/>
    <TradeUseDialog
        ref="tradeUseDialog"
        @sub="tradeUseSuccess"
    />
    <SetBalanceDialog
        ref="setBalanceDialog"
        @sub="setBalanceSuccess"
    />
    <section slot="titleLeft">
      【其他收入金额总计：
      <span class="primary">{{ totalData.transactionAmountSum / 100 }}</span>
      】
    </section>
    <section slot="titleRight">
      <qx-permpisions permpisions="400000000051201">
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>

      <qx-permpisions permpisions="400000000051202" >
        <el-button type="primary" plain @click="toSetBalance()">设置初始余额</el-button>
      </qx-permpisions>

      <qx-permpisions permpisions="400000000051203">
        <ImportBtn
          bizCodes="imp1000128"
          title="其他收入导入"
          fileUrl="/file/其他收入导入模板.xlsx"
        />
      </qx-permpisions>

      <qx-permpisions permpisions="400000000051204">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="incomeAndExpenditureBO.ajax?cmd=queryOtherIncomePage"
          :params="fullSearchData"
          bizName="其他收入数据导出"
          bizCode="exp1000128"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="400000000051205">
        <el-button type="primary" plain @click="toAddTradeUse()">新增交易用途</el-button>
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <el-table-column type="selection" width="55" />
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->

          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <section>
                <!-- 操作按钮 -->
                <qx-permpisions permpisions="400000000051206">
                  <span class="primary cur" @click="toDel(scope.row.id)"
                  >删除</span
                  >
                </qx-permpisions>
                <qx-permpisions permpisions="400000000051207">
                  <span class="primary cur" @click="showLog(scope.row.id)"
                    >日志</span
                  >
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import LogRightDialog from 'components/logRightDialog';
import TradeUseDialog from './tradeUseDialog';
import SetBalanceDialog from './setBalanceDialog';
import ImportBtn from 'components/importBtn';

import TableSetting from 'components/tableSetting/tableSetting';
import {
  otherIncomeList, doRemoveOtherIncome, otherIncomeTotal,
} from 'api/getPay';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    LogRightDialog,
    ImportBtn,
    TradeUseDialog,
    SetBalanceDialog,
    TableSetting,
  },
  data () {
    return {
      totalData: {
        transactionAmountSum: 0,
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        // selectTar: 'orderId',
        title: [ // 表头
          { prop: 'transactionNoFlow', label: '交易编号', fixed: true },
          { prop: 'transactionTime', label: '交易时间' },
          { prop: 'accountName', label: '账户名称' },
          { prop: 'bankCardNo', label: '银行卡号' },
          { prop: 'accountTypeName', label: '账户类型' },
          { prop: 'transactionAmount', label: '收入金额' },
          { prop: 'oppositeAccountNumber', label: '对方账号' },
          { prop: 'oppositeAccountName', label: '对方户名' },
          { prop: 'transactionPurposeName', label: '交易用途', w: '160px' },
          { prop: 'remark', label: '备注' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: otherIncomeList,
    async getOtherMsg (params) {
      const res = await otherIncomeTotal(params);
      if (!res.failed) {
        this.totalData = res;
      }
    },
    toEdit (id) {
      this.jump({
        label: (id ? '修改' : '新增') + '收入',
        url: `/manage/getPay/customer/income/edit${id ? '?id=' + id : ''}`,
        full: true,
      });
    },
    async toDel (id) {
      const confirmRes = await this.$confirm('是否确认删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
      if (confirmRes === 'confirm') {
        const res = await doRemoveOtherIncome({
          id: id,
        });
        if (!res.failed) {
          this.$message.success('删除成功');
          this.getData();
        }
      }
    },
    toAddTradeUse () {
      this.$refs.tradeUseDialog.show();
    },
    toSetBalance (item) {
      this.$refs.setBalanceDialog.show(item);
    },
    tradeUseSuccess () {
      this.getData();
    },
    setBalanceSuccess () {
      this.getData();
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
